import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { push as Push } from 'redux-first-history';

import { PrimaryButton, RegularCampaignIcon, Typography } from '@dev/ee-components';
import { generateIdBasedOnPath, safelyEncodeBase64Url } from '@dev/ee-tools';
import { isNil } from 'lodash-es';

import { getCampaignsStore, SetCampaignCreatorOpen } from '@/store/campaigns/actions';
import { CampaignCreatorType, CampaignsPaths, pathsParams } from '@/services/dictionaries/Paths';
import { useEnableContactHistory } from '@/services/hooks/useEnableContactHistory';
import { CampaignSelectDescribe, SelectCampaignWrapper } from '../../styled';

export const RegularCampaign = (): JSX.Element => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { contactsList, templateName } = useSelector(getCampaignsStore);
    const isAutoresponderAvailable = useEnableContactHistory();

    const clickRegularBtn = (): void => {
        if (isNil(contactsList) || isNil(templateName)) {
            dispatch(Push(CampaignsPaths.CampaignCreator.replace(pathsParams.type, CampaignCreatorType.REGULAR)));
        }
        if (!isNil(contactsList)) {
            dispatch(
                Push(
                    CampaignsPaths.CampaignCreatorTarget.replace(pathsParams.type, CampaignCreatorType.REGULAR).replace(
                        pathsParams.listName,
                        safelyEncodeBase64Url(contactsList)
                    )
                )
            );
        }
        if (!isNil(templateName)) {
            dispatch(
                Push(
                    CampaignsPaths.CampaignCreatorTemplate.replace(
                        pathsParams.type,
                        CampaignCreatorType.REGULAR
                    ).replace(pathsParams.template, safelyEncodeBase64Url(templateName))
                )
            );
        }
        dispatch(SetCampaignCreatorOpen(false));
    };

    return (
        <SelectCampaignWrapper>
            <RegularCampaignIcon />
            <CampaignSelectDescribe>
                <Typography variant="h2">{t('regular')}</Typography>
                <Typography variant="body1" bodyVariant="onPaper" align="center" style={{ margin: '20px 0 32px' }}>
                    {isAutoresponderAvailable ? t('regular_autorespondercampaign_desc') : t('regularcampaign_desc')}
                </Typography>
                <PrimaryButton
                    id={generateIdBasedOnPath('create-regular-campaign-button')}
                    text={t('create')}
                    onClick={clickRegularBtn}
                />
            </CampaignSelectDescribe>
        </SelectCampaignWrapper>
    );
};
